/*
 * This project use mobile first integration
 * Default media is mobile
 */

const sizes = {
  mobile: 400,
  tablet: 700,
  desktop: 1025,
  boxContent: 952,
  boxBigger: 1440,
  mangerBougerTablet: 1100,
  mangerBougerDesktop: 1280,
}

export default sizes
